module.exports = __webpack_public_path__ + "tracinhos.png?5db01793a598ffe7bd9e27ca45d2b989";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tracinhos.png
// module id = 852
// module chunks = 0